import { randomInt, toURL } from '../../../reducers/util';
import { Report, Group, Period } from '../types/CohortReport'
import { SavedReport } from '../types/SavedReport'
import {CONFIG} from "../../../util/config";

export function saveReport(report: Report, queryId: number) {
    return (dispatch: any, getState: any) => {
        _saveReport(report, queryId)
            .then(report => {
                dispatch(setCurrentReportAndRefresh(report))
            })
    }
}

function _saveReport(report: Report, queryId: number) {
    const url = toURL('/report?queryId=' + queryId)
    return fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(report, null, 2),
        ...(CONFIG.isDev && { credentials: 'include' })
    })
        .then(response => response.json())
}

export function refreshSavedReports(queryId: number) {
    return (dispatch: any, getState: any) => {
        const url = toURL('/reports?queryId=' + queryId)
        return fetch(url, {
            ...(CONFIG.isDev && { credentials: 'include' })
        })
            .then(response => response.json())
            .then(reports => dispatch(setSavedReports(reports)))
            .catch(() => console.log('some error happened while fetching the cohort'))
    }

}

export const setSavedReports = (reports: SavedReport) => ({
    type: 'REPORT_SET_SAVED_REPORTS',
    reports
})

export const setCurrentReport = (report: Report) => ({
    type: 'REPORT_SET_CURRENT_REPORT',
    report
})

export function setCurrentReportAndRefresh(report: Report) {
    return (dispatch: any, getState: any) => {
        dispatch(setCurrentReport(report))
        dispatch(refreshSavedReports(report.queryId))
    }
}

export function saveAndThenRunReport(report: Report) {
    return (dispatch: any, getState: any) => {
        _saveReport(report, report.queryId)
            .then(json => {
                dispatch(setCurrentReportAndRefresh(json))
            })
            .then(() => {
                const url = toURL('/runReport?reportId=' + report.id)
                return fetch(url, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    ...(CONFIG.isDev && { credentials: 'include' })
                })
                    .then(response => response.json())
                    .then(json => {
                        dispatch(setCurrentReport(json))
                    })
            })
    }
}

export function loadReport(reportId: number) {
    return (dispatch: any, getState: any) => {
        const url = toURL('/report?reportId=' + reportId)
        return fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            ...(CONFIG.isDev && { credentials: 'include' })
        })
            .then(response => response.json())
            .then(json => dispatch(setCurrentReport(json)))
    }
}

export const setShowDataSource = (dataSource: string, checked: boolean) => ({
    type: 'REPORT_SET_SHOW_DATA_SOURCE',
    dataSource,
    checked
})

export const setReportTitle = (title: string) => ({
    type: 'REPORT_SET_REPORT_TITLE',
    title
})

export const newReport = (queryId: number) => ({
    type: 'REPORT_NEW_REPORT',
    queryId
})

// report index period
export const addIndexPeriod = (period: Period) => ({
    type: 'REPORT_ADD_INDEX_PERIOD',
    period
})

export const updateIndexPeriod = (period: Period) => ({
    type: 'REPORT_UPDATE_INDEX_PERIOD',
    period
})

export const deleteIndexPeriod = (period: Period) => ({
    type: 'REPORT_DELETE_INDEX_PERIOD',
    period
})

// report group
export const createOrUpdateGroup = (group: Group) => ({
    type: 'REPORT_CREATE_OR_UPDATE_GROUP',
    group
})

export const deleteGroup = (group: Group) => ({
    type: 'REPORT_DELETE_GROUP',
    group
})

export const cancelGroup = (group: Group) => ({
    type: 'REPORT_CANCEL_GROUP',
    group
})

// active
export const setActiveTab = (tab: String) => ({
    type: 'REPORT_SET_ACTIVE_TAB',
    tab
})

export const setActiveGroup = (group: Group) => ({
    type: 'REPORT_SET_ACTIVE_GROUP',
    group
})

export const setActivePeriod = (period: Period) => ({
    type: 'REPORT_SET_ACTIVE_PERIOD',
    period
})

// metric
export const setShowMetric = (metric: string, checked: boolean) => ({
    type: 'REPORT_SET_SHOW_METRIC',
    metric,
    checked
})

export const copyReport = (reportId: number) => {
    return (dispatch: any, getState: any) => {
        const url = toURL('/report?reportId=' + reportId)
        return fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            ...(CONFIG.isDev && { credentials: 'include' })
        })
            .then(response => response.json())
            .then(report => {
                const clone = JSON.parse(JSON.stringify(report))
                clone.id = randomInt()
                clone.title = 'Copy of ' + clone.title
                clone.sparkQuery = null
                dispatch(setCurrentReport(clone))
            })
    }
}
export const deleteReport = (reportId: number) => {
    return (dispatch: any, getState: any) => {
        const queryId = getState().current.queryId
        const url = toURL(`/report?reportId=${reportId}`)
        return fetch(url, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            ...(CONFIG.isDev && { credentials: 'include' })
        }).then(response => {
            dispatch(refreshSavedReports(queryId))
            dispatch(newReport(queryId))
        })
    }
}